import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Loader2 } from "lucide-react";
import { publicApi } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [pollCount, setPollCount] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const interval = setInterval(async () => {
      try {
        const s = await publicApi.paymentStatus(sessionId);
        if (cancelled) return;
        setPollCount((c) => c + 1);
        if (s.payment_status === "paid") {
          setStatus("paid");
          clearInterval(interval);
        } else if (["failed", "expired", "refunded"].includes(s.payment_status)) {
          setStatus(s.payment_status);
          clearInterval(interval);
        } else if (pollCount > 20) {
          setStatus("timeout");
          clearInterval(interval);
        }
      } catch {}
    }, 2000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [sessionId]);

  return (
    <div className="dr-shell flex min-h-screen items-center justify-center px-6" data-testid="payment-success-page">
      <div className="w-full text-center">
        {status === "paid" ? (
          <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}>
            <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#E1FF00]/10">
              <CheckCircle2 size={44} className="text-[#E1FF00]" />
            </div>
            <h1 className="mt-6 font-display text-4xl text-white">Unlocked</h1>
            <p className="mt-3 text-sm text-zinc-400">Today's card is yours. Good luck.</p>
            <Link
              to="/"
              data-testid="success-view-tip"
              className="dr-btn-primary mt-8 inline-flex rounded-full px-8 py-3"
            >
              View today's tip
            </Link>
          </motion.div>
        ) : (
          <div>
            <Loader2 className="mx-auto animate-spin text-[#E1FF00]" size={36} />
            <p className="mt-4 text-sm text-zinc-400">
              {status === "polling" ? "Confirming payment…" : `Status: ${status}`}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
